module.exports = __webpack_public_path__ + "img/AipromptWords.09acddcf.gif";